import { gql } from "@apollo/client";

export const PARAMETER = gql`
  query queryParameter($key: String!) {
    parameter(key: $key) {
      id
      name
      key
      value
      franchise_id
      acting_region_id
      is_deleted
    }
  }
`;

export const PARAMETERS = gql`
  query queryParameters($franchise_id: Float, $acting_region_id: Float) {
    parameters(franchise_id: $franchise_id, acting_region_id: $acting_region_id) {
      id
      name
      key
      value
      franchise_id
      acting_region_id
      is_deleted
    }
    franchises {
      id
      name
    }
    regions(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export default PARAMETER;
